"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PROGRESS = void 0;
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const utilities_1 = __importStar(require("jsAssets/utilities"));
const react_redux_1 = require("react-redux");
const index_1 = __importDefault(require("./ReviewStageAccordion/index"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const StageReviewDecisionOverride_1 = __importDefault(require("../StageReviewDecisionOverride"));
const review_grid_constant_1 = require("../../constants/review-grid-constant");
const helper_1 = require("../../helper");
const reviewSlice_1 = require("../../../asset-detail/store/reviewSlice");
const review_stages_1 = require("../../constants/review-stages");
const stage_review_decision_override_types_1 = require("../StageReviewDecisionOverride/stage-review-decision-override-types");
const index_2 = __importDefault(require("./ReviewSetting/index"));
const store_1 = __importDefault(require("../../../reviews-modal/store"));
exports.DEFAULT_PROGRESS = {
    notified: false,
    opened: false,
    commented: false,
    completed: false,
};
const ReviewStagesDetail = (props) => {
    var _a;
    const IS_REVIEW_ADMIN = helper_1.REVIEWS_ADMIN_PERMISSION === 'y';
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleDecisionChange = async (member, stageId, decision, completed) => {
        dispatch((0, reviewSlice_1.updateReviewDecision)({
            member,
            stageId,
            decisionId: decision.id,
            completed,
        }));
    };
    const [decisionStatuses, setDecisionStatuses] = (0, react_1.useState)([]);
    const [noPermissionDecisionStatuses, setNoPermissionDecisionStatuses] = (0, react_1.useState)([]);
    const [isOpenAllStage, setIsOpenAllStage] = (0, react_1.useState)(false);
    const [roundStages, setRoundStages] = (0, react_1.useState)(props.roundStages);
    const [numberExpandedStages, setNumberExpandStages] = (0, react_1.useState)(0);
    const { reviewRound, setOpenReviewModal } = (0, react_redux_1.useSelector)((state) => state.review);
    (0, react_1.useEffect)(() => {
        if (decisionStatuses.length === 0) {
            pulse_components_1.v2Endpoint
                .get(`${helper_1.URLS.pulse}v2/api/decision-statuses`)
                .then((res) => {
                const { data } = res;
                const formattedData = (0, utilities_1.parseJsonApi)((0, utilities_1.camelizeKeys)(data));
                const statuses = formattedData.map((item) => {
                    return {
                        label: item.label,
                        value: item.name,
                        id: item.id,
                    };
                });
                const inProgressStatus = formattedData.find((status) => status.name === stage_review_decision_override_types_1.DecisionStatus.inProgress);
                const completeStatus = formattedData.find((status) => status.name === stage_review_decision_override_types_1.DecisionStatus.approved);
                setDecisionStatuses(statuses);
                if (inProgressStatus && completeStatus) {
                    setNoPermissionDecisionStatuses([
                        {
                            id: Number(inProgressStatus.id),
                            value: `${inProgressStatus.name}`,
                            label: 'In Progress',
                        },
                        {
                            id: Number(completeStatus.id),
                            value: completeStatus.name,
                            label: 'Review Complete',
                        },
                    ]);
                }
            })
                .catch((error) => {
                utilities_1.default.notification.danger(error);
            });
        }
    }, []);
    const onChangeAccordion = (expanded) => {
        if (expanded) {
            if (numberExpandedStages + 1 === (roundStages === null || roundStages === void 0 ? void 0 : roundStages.stages.length)) {
                setIsOpenAllStage(true);
            }
            setNumberExpandStages(numberExpandedStages + 1);
        }
        else {
            if (numberExpandedStages - 1 === 0) {
                setIsOpenAllStage(false);
            }
            setNumberExpandStages(numberExpandedStages - 1);
        }
    };
    const handleExpandAll = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const listStage = ((_a = props.roundStages) === null || _a === void 0 ? void 0 : _a.stages.map((stage) => {
            return {
                ...stage,
                isOpen: !isOpenAllStage,
            };
        })) || [];
        if (props.roundStages) {
            setRoundStages({ ...props.roundStages, stages: listStage });
            dispatch((0, reviewSlice_1.setAccordionReviewWholeStageStatePath)({
                roundId: (_c = (_b = props === null || props === void 0 ? void 0 : props.roundStages) === null || _b === void 0 ? void 0 : _b.roundId) !== null && _c !== void 0 ? _c : (_d = props === null || props === void 0 ? void 0 : props.roundStages) === null || _d === void 0 ? void 0 : _d.id,
                isOpen: !isOpenAllStage,
                allStages: (_f = (_e = props.roundStages) === null || _e === void 0 ? void 0 : _e.stages) !== null && _f !== void 0 ? _f : [],
            }));
        }
        setIsOpenAllStage(!isOpenAllStage);
        if (numberExpandedStages === ((_g = props.roundStages) === null || _g === void 0 ? void 0 : _g.stages.length)) {
            setNumberExpandStages(0);
        }
        else {
            setNumberExpandStages((_h = props.roundStages) === null || _h === void 0 ? void 0 : _h.stages.length);
        }
    };
    (0, react_1.useEffect)(() => {
        setRoundStages(props.roundStages);
    }, [props.roundStages]);
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default.reviewStages },
        react_1.default.createElement("div", { className: styles_modules_less_1.default.header },
            react_1.default.createElement("div", { className: styles_modules_less_1.default.status },
                react_1.default.createElement("div", { className: styles_modules_less_1.default.headerTitle }, "REVIEW STAGES"),
                react_1.default.createElement(pulse_components_1.PulseStatusProgress, { view: "review", progress: (roundStages === null || roundStages === void 0 ? void 0 : roundStages.progress) || exports.DEFAULT_PROGRESS, deactiveColor: review_grid_constant_1.COLOR_SOCD_BG.grey, classes: {
                        root: styles_modules_less_1.default.processStatus,
                    } })),
            react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-buttons'] },
                react_1.default.createElement(react_redux_1.Provider, { store: store_1.default },
                    react_1.default.createElement(index_2.default, { reviewRound: reviewRound, setOpenReviewModal: setOpenReviewModal })),
                react_1.default.createElement("div", { className: styles_modules_less_1.default['expand-all-btn'], onClick: handleExpandAll },
                    react_1.default.createElement("span", null, isOpenAllStage ? 'Collapse All' : 'Expand All')))),
        react_1.default.createElement("div", { className: styles_modules_less_1.default.stages }, (_a = roundStages === null || roundStages === void 0 ? void 0 : roundStages.stages) === null || _a === void 0 ? void 0 : _a.map((stage, stageIndex) => {
            var _a, _b;
            const stageStatus = stage === null || stage === void 0 ? void 0 : stage.status;
            const isManageReviewer = (_a = stage === null || stage === void 0 ? void 0 : stage.reviewers) === null || _a === void 0 ? void 0 : _a.some((reviewer) => reviewer.manage && Number(helper_1.USER.id) === reviewer.id);
            return (react_1.default.createElement(index_1.default, { isEdit: false, stage: stage, key: stage.id, onChange: onChangeAccordion, stageIndex: stageIndex, roundId: roundStages === null || roundStages === void 0 ? void 0 : roundStages.id, accordionReviewStageStatePath: props === null || props === void 0 ? void 0 : props.accordionReviewStageStatePath, stages: roundStages === null || roundStages === void 0 ? void 0 : roundStages.stages }, (_b = stage === null || stage === void 0 ? void 0 : stage.reviewers) === null || _b === void 0 ? void 0 : _b.map((reviewer, indexMember) => {
                const isCurrentUser = reviewer.id === Number(helper_1.USER.id);
                const canChangeDecision = IS_REVIEW_ADMIN || isManageReviewer || isCurrentUser;
                let memberDecisionStatus = '';
                if (reviewer.decision) {
                    memberDecisionStatus = reviewer.decisionStatus;
                }
                else {
                    memberDecisionStatus = reviewer.progress.completed
                        ? stage_review_decision_override_types_1.DecisionStatus.approved
                        : stage_review_decision_override_types_1.DecisionStatus.inProgress;
                }
                return (react_1.default.createElement(pulse_components_1.PulseAccordionDetails, { className: styles_modules_less_1.default.accorDetails, key: indexMember },
                    react_1.default.createElement("div", { className: styles_modules_less_1.default.reviewers },
                        react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                                allowHTML: true,
                                placement: 'left',
                                popperOptions: {
                                    strategy: 'fixed',
                                },
                                content: (react_1.default.createElement("div", { className: styles_modules_less_1.default.avtTooltip },
                                    react_1.default.createElement("img", { src: reviewer.avatarUrl, alt: "avatar", className: styles_modules_less_1.default.avtHover }),
                                    react_1.default.createElement("div", { className: styles_modules_less_1.default.avtTooltipInfo },
                                        react_1.default.createElement("span", { className: styles_modules_less_1.default.avtName }, reviewer === null || reviewer === void 0 ? void 0 : reviewer.name),
                                        react_1.default.createElement("span", null, reviewer === null || reviewer === void 0 ? void 0 : reviewer.email),
                                        react_1.default.createElement("span", null, reviewer === null || reviewer === void 0 ? void 0 : reviewer.clientName),
                                        react_1.default.createElement("span", null, reviewer === null || reviewer === void 0 ? void 0 : reviewer.category),
                                        react_1.default.createElement("span", null, reviewer === null || reviewer === void 0 ? void 0 : reviewer.role)))),
                            } },
                            react_1.default.createElement("img", { src: reviewer.avatarUrl, alt: "avatar", className: styles_modules_less_1.default.reviewerAvatar })),
                        react_1.default.createElement("span", { className: styles_modules_less_1.default.reviewerName }, reviewer.name),
                        reviewer.id === (roundStages === null || roundStages === void 0 ? void 0 : roundStages.ownerId) && (react_1.default.createElement(pulse_components_1.PulseChip, { classes: {
                                root: styles_modules_less_1.default.chipButton,
                            }, color: "#eee", fontSize: 11, fontColor: "black", label: "Review Author", PulseTooltipProps: {
                                TippyProps: {
                                    popperOptions: {
                                        strategy: 'fixed',
                                    },
                                },
                            } }))),
                    react_1.default.createElement(pulse_components_1.PulseStatusProgress, { progress: stageStatus !== review_stages_1.STAGE_STATUS.notStarted
                            ? (0, helper_1.getProgressSOCD)(reviewer.progress, review_grid_constant_1.SOCD_VIEW.userDecision).progressStep
                            : exports.DEFAULT_PROGRESS, view: (0, helper_1.getProgressSOCD)(reviewer.progress, review_grid_constant_1.SOCD_VIEW.userDecision).view, deactiveColor: review_grid_constant_1.COLOR_SOCD_BG.grey, classes: {
                            root: styles_modules_less_1.default.processStatusDetails,
                        } }),
                    react_1.default.createElement("div", { className: styles_modules_less_1.default.statusDetails }, stageStatus !== review_stages_1.STAGE_STATUS.notStarted &&
                        reviewer.decisionStatusLabel && (react_1.default.createElement(StageReviewDecisionOverride_1.default, { handleDecisionChange: (decisionType) => handleDecisionChange(reviewer.id, stage.id, decisionType, decisionType.value !== 'in_progress' ||
                            reviewer.decision).then(() => {
                            // reload grid events
                            const reloadGridEvent = new CustomEvent('reload-review-grid', {
                                detail: {
                                    status: 200,
                                },
                            });
                            document.dispatchEvent(reloadGridEvent);
                        }), decisionStatuses: reviewer.decision
                            ? decisionStatuses
                            : noPermissionDecisionStatuses, selected: memberDecisionStatus, decisionChangeEnabled: canChangeDecision })))));
            })));
        }))));
};
exports.default = react_1.default.memo(ReviewStagesDetail);
